import { Slide, Button, Dialog, DialogTitle, DialogContent,  DialogActions,  AvatarGroup, Card, CardContent, Divider } from '@mui/material';
import { TransitionProps } from '@mui/material/transitions';
import React from 'react'
import moment from 'moment';
import map from "../../../assets/map.jpg"
import PushPinRoundedIcon from '@mui/icons-material/PushPinRounded';
import FmdGoodRoundedIcon from '@mui/icons-material/FmdGoodRounded';
import PlacementApi from '../../../store/services/placement';
import UserApi from '../../../store/services/user';
import { useAppDispatch } from '../../../store/hooks/hooks';
import { StudentActions } from '../../../store/StudentAction';
import { useNavigate } from 'react-router-dom';
import UserAvatar from '../../../utils/Avatar/Avatar';
import Avatar from '../../../utils/Avatar/Avatar';

const Transition = React.forwardRef(function Transition(
    props: TransitionProps & {
        children: React.ReactElement<any, any>;
    },
    ref: React.Ref<unknown>,
) {
    return <Slide direction="up" ref={ref} {...props} />;
});

const EventNotificationModal = (props: any) => {
    const [open, setOpen] = React.useState(false)
    const dispatch = useAppDispatch()
    const navigate = useNavigate()
    const handleClickOpen = () => {
        setOpen(true);
    };
    const updateEvent = (status: boolean, notification: any) => {
        if (status) {
            let body = {
                eventId: notification.EventId,
                rejectedParticipants: [],
                acceptedParticipants: [notification.targetUserId]
            }
            PlacementApi.respondEventRequest(body).then(res => {
                UserApi.updateNotification({ id: notification._id, status: true }).then(res => {
                    handleClose()
                    props.fetchNotifications()
                    dispatch(StudentActions.setMessage(`Notification Accepted.`))
                })
            }).catch((e) => {
                if (e.response.status === 403) {
                    navigate('/login')
                }
                handleClose()
                dispatch(StudentActions.setMessage("Notification Updation Failed.Try again."))
            })

        }
        else {
            let body = {
                eventId: notification.EventId,
                rejectedParticipants: [notification.targetUserId],
                acceptedParticipants: []
            }
            PlacementApi.respondEventRequest(body).then(res => {
                UserApi.updateNotification({ id: notification._id, status: false }).then(res => {
                    handleClose()
                    props.fetchNotifications()
                    dispatch(StudentActions.setMessage(`Notification Declined.`))
                })
            }).catch((e) => {
                console.log(e)
                if (e.response.status === 403) {
                    navigate('/login')
                }
                dispatch(StudentActions.setMessage("Notification Updation Failed.Try again."))
            })
        }
    }

    const switchEventType = () => {
        switch (props.event.EventType) {
            case 'TM':
                return (
                    <div className='flex flex-column'>
                        <div className='flex justify-content-between m-2 '>
                            <p className='gray-color m-0'>Event Type:</p>
                            <p className='font-weight-700 m-0'>Meeting</p>
                        </div>
                        <div className='flex justify-content-between m-2 '>
                            <p className='gray-color m-0'>Event Title:</p>
                            <p className='font-weight-700 m-0'>{props.event.details.title}</p>
                        </div>
                        <div className='flex justify-content-between m-2 '>
                            <p className='gray-color m-0'>Location:</p>
                            <p className='font-weight-700 m-0'>{props.event.details?.location}</p>
                        </div>
                        <div className='flex justify-content-between m-2 '>
                            <p className='gray-color m-0'>Timings:</p>
                            <p className='font-weight-700 m-0'>{moment(props.event.details?.From).format("MMMM Do YYYY, hA")} - {moment(props.event.details?.To).format("MMMM Do YYYY, hA")}</p>
                        </div>
                        <div className='flex justify-content-between m-2 '>
                            <div className='flex '>
                                <p className='gray-color m-0'>Participants:</p>
                                <AvatarGroup className='mx-3'>
                                    {
                                        props.event.details.participants && props.event.details.participants.map((elm: any) => {
                                            if (props.event.details.acceptedParticipants.includes(elm.Student_ID ? elm.Student_ID : elm.Id)) {
                                                return (
                                                    <UserAvatar key={elm._id} name={`${elm.first_name} ${elm.last_name}`} status={1} badge={true} />
                                                )
                                            }
                                            else if (props.event.details.rejectedParticipants.includes(elm.Student_ID ? elm.Student_ID : elm.Id)) {
                                                return (
                                                    <UserAvatar key={elm._id} name={`${elm.first_name} ${elm.last_name}`} status={0} badge={true} />
                                                )
                                            }
                                            else {
                                                return (
                                                    <UserAvatar key={elm._id} name={`${elm.first_name} ${elm.last_name}`} status={-1} badge={true} />
                                                )
                                            }


                                        })
                                    }
                                </AvatarGroup>

                            </div>
                            {
                                !props.notifications.Updated ? <div className='mt-2' >
                                    <Button variant='contained' size='small' className='mx-2' onClick={() => {
                                        updateEvent(true, props.notifications)
                                    }}>Accept</Button>
                                    <Button variant='outlined' size='small' onClick={() => {
                                        updateEvent(false, props.notifications)
                                    }}>Decline</Button>
                                </div> :   <Button variant='contained'>Join</Button>
                            }
                        </div>
                    </div>
                )
            case 'PV':
                return (
                    <div className='align-items-center flex flex-column'>
                        <div className='flex justify-content-between m-2 w-50'>
                            <p className='gray-color m-0'>Event Type:</p>
                            <p className='font-weight-700 m-0'>Placement Visit</p>
                        </div>
                        <div className='flex justify-content-between m-2 w-50'>
                            <p className='gray-color m-0'>Event Title:</p>
                            <p className='font-weight-700 m-0'>{props.event.details?.title}</p>
                        </div>
                        <div className='flex flex-column justify-content-between m-2 w-50'>
                            <p className='gray-color m-0'>Route Path:</p>
                            <div className='m-1 flex routeScrollContainer flex-row'>
                                {
                                    props.event.details.participants && props.event.details.participants.map((placementDetails: any, index: any) => {
                                        return (
                                            <div key={index} className="flex">
                                                <Card className={index !== props.event.details.participants.length - 1 ? 'routeCard m-2' : 'destinationContainer routeCard m-2'}>
                                                    <CardContent className='flex align-items-center'>
                                                        <div className='routeIconContainer align-items-center flex justify-content-center m-2 p-2'>
                                                            <img src={map} style={{ height: "80px", borderRadius: "4px" }}></img>
                                                            {/* <ExploreRoundedIcon className='gray-color m-0' fontSize='small'></ExploreRoundedIcon> */}
                                                        </div>
                                                        <div className='m-1'>
                                                            <div className='flex p-1'>
                                                                <PushPinRoundedIcon className='gray-color m-0' fontSize='small'></PushPinRoundedIcon>
                                                                <p className='routeCardText m-0 mx-1'>{placementDetails.placement.CompanyName}</p>
                                                            </div>
                                                            <div className='flex p-1'>
                                                                <FmdGoodRoundedIcon className='gray-color m-0' fontSize='small'></FmdGoodRoundedIcon>
                                                                <p className='routeCardText m-0 mx-1'>{placementDetails.placement.RegAddressPostCode}</p>
                                                            </div>
                                                            <div className='flex p-1'>
                                                                <Avatar name={`${placementDetails.user.first_name} ${placementDetails.user.last_name}`}></Avatar>
                                                                <p className='routeCardText m-0 mx-1'>{`${placementDetails.user.first_name} ${placementDetails.user.last_name}`}</p>
                                                            </div>
                                                        </div>
                                                    </CardContent>
                                                </Card>
                                                {
                                                    index !== props.event.details.participants.length - 1 && <div className='align-items-center flex justify-content-center dividerContainer'>
                                                        <Divider className='dividerWidth' />
                                                    </div>
                                                }
                                            </div>
                                        )
                                    })
                                }
                            </div>
                        </div>
                        <div className='flex justify-content-between m-2 w-50 '>
                            <p className='gray-color m-0'>Scheduled:</p>
                            <p className='font-weight-700 m-0'>{moment(props.event.details?.scheduleDate).format("MMMM Do YYYY, hA")}</p>
                        </div>
                        <div className='flex justify-content-between m-2 w-50'>
                            <div className='flex'>
                                <p className='gray-color m-0'>Participants:</p>
                                <AvatarGroup className='mx-3'>
                                    {
                                        props.event.details.participants && props.event.details.participants.map((elm: any) => {
                                            if (props.event.details.acceptedParticipants.includes(elm.user.Student_ID ? elm.user.Student_ID : elm.user.Id)) {
                                                return (
                                                    <UserAvatar key={elm._id} name={`${elm.user.first_name} ${elm.user.last_name}`} status={1} badge={true} />
                                                )
                                            }
                                            else if (props.event.details.rejectedParticipants.includes(elm.user.Student_ID ? elm.user.Student_ID : elm.user.Id)) {
                                                return (
                                                    <UserAvatar key={elm._id} name={`${elm.user.first_name} ${elm.user.last_name}`} status={0} badge={true} />
                                                )
                                            }
                                            else {
                                                return (
                                                    <UserAvatar key={elm._id} name={`${elm.user.first_name} ${elm.user.last_name}`} status={-1} badge={true} />
                                                )
                                            }


                                        })
                                    }
                                </AvatarGroup>
                            </div>
                            {
                                !props.notifications.Updated ? <div className='mt-2' >
                                    <Button variant='contained' size='small' className='mx-2' onClick={() => {
                                        updateEvent(true, props.notifications)
                                    }}>Accept</Button>
                                    <Button variant='outlined' size='small' onClick={() => {
                                        updateEvent(false, props.notifications)
                                    }}>Decline</Button>
                                </div> :   <Button variant='contained'>Join</Button>
                            }
                        </div>
                    </div>
                )
        }
    }

    const handleClose = () => {
        setOpen(false);
    };
    console.log(props)
    return (
        <div>
            <Button variant='contained' size='small' className='mx-2' onClick={handleClickOpen}>View</Button>
            <Dialog
                open={open}
                TransitionComponent={Transition}
                onClose={handleClose}
                aria-describedby="alert-dialog-slide-description"
            >
                <DialogTitle>Event Details</DialogTitle>
                <DialogContent>
                    <div className='flex justify-content-center'>
                        {
                           props.event && Object.keys(props.event).length > 0 &&  switchEventType()
                        }
                    </div>
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleClose}>Close</Button>
                </DialogActions>
            </Dialog>
        </div>
    )
}
export default EventNotificationModal;